export const article = `毛泽东（1893年12月26日-1976年9月9日），字润之（原作咏芝，后改润
芝），笔名子任。湖南湘潭人。中国人民的领袖，伟大的马克思主义者，无产阶级革命家、战
略家和理论家，中国共产党、中国人民解放军和中华人民共和国的主要缔造者和领导人，诗人
，书法家。1949至1976年，毛泽东担任中华人民共和国最高领导人。他对马克思列宁主义的发
展、军事理论的贡献以及对共产党的理论贡献被称为毛泽东思想。因毛泽东担任过的主要职务
几乎全部称为主席，所以也被人们尊称为“毛主席”。毛泽东被视为现代世界历史中最重要的人
物之一，《时代》杂志也将他评为20世纪最具影响100人之一。`;

export const btns = [
  {
    variant: 'primary',
    text: '日期',
  },
  {
    variant: 'secondary',
    text: '地点',
  },
  {
    variant: 'success',
    text: '时间',
  },
  {
    variant: 'warning',
    text: '人名',
  },
  {
    variant: 'danger',
    text: '国家',
  },
];
